import { render } from "./PreviewTranscription.vue?vue&type=template&id=a3b0fa0a"
import script from "./PreviewTranscription.vue?vue&type=script&lang=js"
export * from "./PreviewTranscription.vue?vue&type=script&lang=js"

import "./PreviewTranscription.vue?vue&type=style&index=0&id=a3b0fa0a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__